var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"filter-v-alert",attrs:{"color":"primary","dense":"","dismissible":"","text":"","close-icon":"close","height":"32"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }